import salaMusculacion from './assets/salaMusculacion.webp';
import zonaCardio from './assets/zonaCardio.webp';
import salaBicis from './assets/salaBicis.webp';
import clasesColectivas from './assets/clasesColectivas.jpeg';
import zonaFuncional from './assets/zonaFuncional.jpg';

// Mock data para Infinity Gym Landing Page

export const gymInfo = {
  name: "Infinity Gym S.L.",
  slogan: "Tu mejor versión empieza hoy",
  description: "En Infinity Gym creemos que cada persona tiene un potencial infinito. Nuestro gimnasio combina equipamiento de última generación, entrenadores profesionales y un ambiente motivador para ayudarte a alcanzar tus objetivos fitness.",
  philosophy: "Somos más que un gimnasio. Somos una comunidad comprometida con tu bienestar y transformación personal. Con más de 10 años de experiencia, ofrecemos un espacio donde profesionalidad y cercanía se unen para ofrecerte la mejor experiencia de entrenamiento."
};

export const services = [
  {
    id: 1,
    title: "Sala de Musculación",
    description: "Equipamiento profesional de última generación para entrenamiento de fuerza y hipertrofia.",
    icon: "dumbbell"
  },
  {
    id: 2,
    title: "Zona de Cardio",
    description: "Amplia zona con cintas, bicicletas y elípticas para tu entrenamiento cardiovascular.",
    icon: "heart-pulse"
  },
  {
    id: 3,
    title: "Clases Colectivas",
    description: "Spinning, Zumba, Pilates, Boxeo y más. Entrenamientos en grupo con instructores certificados.",
    icon: "users"
  },
  {
    id: 4,
    title: "Rutinas Personalizadas",
    description: "Generación de rutinas personalizadas con entrenadores expertos adaptadas a tus objetivos.",
    icon: "target"
  },
  {
    id: 5,
    title: "Zona Funcional",
    description: "Espacio dedicado a entrenamiento funcional y preparación atlética.",
    icon: "activity"
  },
  {
    id: 6,
    title: "Vestuarios Premium",
    description: "Instalaciones modernas con duchas, taquillas y zona de cortesía.",
    icon: "sparkles"
  }
];

export const gymRating = {
  overall: 4.8,
  totalReviews: 120
};

export const testimonials = [
  {
    id: 1,
    name: "Ana M.",
    comment: "Excelente gimnasio, muy bien equipado y con personal muy atento. El ambiente es genial para entrenar.",
    rating: 5
  },
  {
    id: 2,
    name: "Miguel S.",
    comment: "Llevo varios meses entrenando aquí y estoy muy contento. Buenas instalaciones y buen precio.",
    rating: 5
  },
  {
    id: 3,
    name: "Laura P.",
    comment: "Muy buen gimnasio, limpio y con todo lo necesario. Los monitores son muy profesionales.",
    rating: 4
  },
  {
    id: 4,
    name: "Carlos R.",
    comment: "Recomendable 100%. Buen ambiente, máquinas en perfecto estado y horarios flexibles.",
    rating: 5
  },
  {
    id: 5,
    name: "Patricia G.",
    comment: "Me encanta este gym! Está muy bien equipado y el personal es súper amable. Totalmente recomendado.",
    rating: 5
  },
  {
    id: 6,
    name: "Javier L.",
    comment: "Gimnasio completo con todo tipo de máquinas. El trato es excelente y las instalaciones están siempre limpias.",
    rating: 4
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Plan Mensual",
    price: "36",
    period: "mes",
    features: [
      "Acceso ilimitado al gimnasio",
      "Zona de musculación y cardio",
      "Vestuarios y duchas"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Plan Trimestral",
    price: "33",
    period: "mes",
    features: [
      "Acceso ilimitado al gimnasio",
      "Zona de musculación y cardio",
      "Vestuarios y duchas"
    ],
    popular: true,
    savings: "Ahorra 9€ al trimestre"
  },
  {
    id: 3,
    name: "Plan Semestral",
    price: "32.50",
    period: "mes",
    features: [
      "Acceso ilimitado al gimnasio",
      "Zona de musculación y cardio",
      "Vestuarios y duchas"
    ],
    popular: false,
    savings: "Ahorra 21€ al semestre"
  }
];

export const bonusOptions = [
  { name: "Bono 10 días", price: "31 €", detail: "Caduca en 3 meses" },
  { name: "Pase de día libre", price: "5 €", detail: "" },
  { name: "Día de prueba", price: "5 €", detail: "Se descuenta del primer mes al darse de alta" },
  { name: "Semana completa", price: "10 €", detail: "7 días seguidos" },
  { name: "Medio mes", price: "desde 20 €", detail: "15 días seguidos" }
];

export const otherConcepts = [
  { name: "Matrícula", price: "10 €" },
  { name: "Pulsera obligatoria", price: "5 €" },
  { name: "Pérdida o rotura de pulsera", price: "5 €" },
  { name: "Tabla de musculación personalizada", price: "6 €" }
];

export const location = {
  address: "Plaza de toros, locales parte de atrás, C. Rafael Alberti, 0, 28813 Torres de la Alameda, Madrid",
  schedule: "Lunes a Viernes: 9:00 - 21:30 | Sábado: 9:00 - 14:00 | Domingo: Cerrado",
  description: "Ubicados en Torres de la Alameda con fácil acceso y aparcamiento disponible. Ven a visitarnos y descubre nuestras instalaciones.",
  phone: "691 91 39 07",
  email: "info@infinitygym.com"
};

export const galleryImages = [
  {
    id: 1,
    alt: "Sala de musculación",
    src: salaMusculacion,
    placeholder: "from-zinc-800 to-zinc-900"
  },
  {
    id: 2,
    alt: "Zona de cardio",
    src: zonaCardio,
    placeholder: "from-emerald-900 to-zinc-900"
  },
  {
    id: 3,
    alt: "Sala de spinning",
    src: salaBicis,
    placeholder: "from-zinc-900 to-emerald-900"
  },
  {
    id: 4,
    alt: "Clases colectivas",
    src: clasesColectivas,
    placeholder: "from-zinc-800 to-zinc-900"
  },
  {
    id: 5,
    alt: "Zona funcional",
    src: zonaFuncional,
    placeholder: "from-emerald-900 to-zinc-800"
  }
];

export const socialMedia = [
  { name: "Instagram", url: "https://www.instagram.com/infinitygym_torresdelaalameda/", icon: "instagram" },
  { name: "Facebook", url: "https://www.facebook.com/InfinityGymTorres/?locale=es_LA", icon: "facebook" }
];
